import {TextField, IconButton} from "@material-ui/core";
import {Clear} from "@material-ui/icons";
import React, {useState} from "react";

export default function Field({label, value, updator}) {
  const [currentValue, setValue] = useState((value ?? "").toString());
  return (
    <span
      style={{
        margin: "0.25em 1em",
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-end",
        maxWidth: "8em",
      }}
    >
      <TextField
        style={{width: "100%", textTransform: "capitalize"}}
        label={label}
        value={currentValue}
        onChange={event => setValue(event.target.value)}
        onBlur={() => updator(currentValue)}
      />
      {value && (
        <IconButton
          size="small"
          onClick={() => {
            setValue("");
            updator("");
          }}
        >
          <Clear />
        </IconButton>
      )}
    </span>
  );
}
